import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import Field from "../../../components/Fields/Field";
import FieldLabel from "../../../components/Fields/FieldLabel";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemTypeModel from "../../../models/ItemTypeModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

interface ItemTypeBomTemplate {
    name: string
    itemTypeId: number
    productCategoryId: number
    beginDate: string
    endDate: string
    concurrencyId: string
}

interface Props extends PopupProps {
    itemType: ItemTypeModel

}

const AddItemTypeBomTemplatePopup: React.FC<Props> = ({ show, onHide, itemType }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const navigate = useNavigate()
    const [formData, setFormData] = useState<ItemTypeBomTemplate>();

    const productCategories = useSelectListOptions('api/v1/selectlist/ProductCategoryNameTreeLeaves', '-- Select product category');

    useEffect(() => {
        setFormData({
            name: '',
            itemTypeId: itemType.id,
            productCategoryId: 0,
            beginDate: new FormatUtils().formatDateForStorage(new Date()),
            endDate: '',
            concurrencyId: ''
        })
    }, [itemType.id]);

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/BillOfMaterialTemplates/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data) {
                        const url = '/plm/ItemSetup/BillOfMaterialTemplate/' + response.data;
                        navigate(url);
                    }

                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'productCategoryId', label: 'Category', labelSize: 3},
            { name: 'beginDate', label: 'Active from', labelSize: 3, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getLabelProps, getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={{ format: 'New Bill-of-Materials template for {0}', args: [itemType.name] }} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <SelectListField {...getFieldProps('productCategoryId')} options={productCategories} />
                <Field {...getLabelProps('beginDate')}>
                    <DateControl {...getControlProps('beginDate')} />
                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                    <DateControl {...getControlProps('endDate')} />
                </Field>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddItemTypeBomTemplatePopup;